import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { siteAdministratorsKeys } from '../../api/query-keys/administrators';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { editAdminRole } from '../../api/lib/admins';
import { UserRole } from 'src/types/enum/user-role';

export const useEditAdminRole = (onSuccess?: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      siteAdminToken,
      role,
    }: {
      siteAdminToken: string;
      role: UserRole;
    }) => editAdminRole(siteAdminToken, role),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: siteAdministratorsKeys.lists(),
        });
      });

      onSuccess?.();

      toast.success(
        t('siteManagement:administrators.editAdminRoleDialog.success'),
      );
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
